var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconImprint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "F\\xFCllung",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256.82,32.81c-123.52,0-224,100.49-224,224s100.48,224,224,224,224-100.48,224-224S380.33,32.81,256.82,32.81Zm0,416c-105.87,0-192-86.13-192-192s86.13-192,192-192,192,86.14,192,192S362.68,448.81,256.82,448.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316.47,342H272V186a16,16,0,0,0-16-16H217.82a16,16,0,0,0,0,32H240V342H195.53a16,16,0,1,0,0,32H316.47a16,16,0,0,0,0-32Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 124.38,
    r: 22.43,
    transform: "translate(-8.17 18.46) rotate(-4.07)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImprint);
export default __webpack_public_path__ + "static/media/icon-imprint.5a9a4e77.svg";
export { ForwardRef as ReactComponent };